import { render, staticRenderFns } from "./HelpPageBtn.vue?vue&type=template&id=88a503e4&"
import script from "./HelpPageBtn.vue?vue&type=script&lang=js&"
export * from "./HelpPageBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports